import { apiBlog } from "../../../../services/api"

export async function uploadImagePost(image) {
  if (!image) {
    return
  }
  const formData = new FormData()
  formData.append('file', image)

  try {
    const response = await apiBlog.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  
    return response.data
  } catch (error) {
    console.log(error)
  }

}